<template>
    <div>
        <div style="text-align: center">
            <h3>Tambah Group Greeter</h3>
        </div>
        <br />
        <form v-on:submit.prevent="addGroupGreeter">
            <label>Nama Group Greeter</label>
            <input type="text" class="form-control" v-model="form.name" autofocus required />
            <br />
            <label>Device</label>
            <multiselect v-model="form.device" tag-placeholder="Pilih Device Pengirim"
                placeholder="Pilih Device Pengirim" label="name" :custom-label="customLabel" track-by="id"
                :options="device">
            </multiselect>
            <br />
            <label>Pilih Group</label>
            <br>
            <div v-if="!isGroupLoaded">
                <button v-if="loading.isGroupLoading" class="btn btn-primary btn-sm" disabled>
                    <div class="spinner-border spinner" role="status"></div>
                    Loading...
                </button>
                <button v-else type="button" v-on:click="loadGroup(form.device)" class="btn btn-primary btn-sm">Load
                    Group</button>
            </div>
            <div v-else>
                <multiselect v-model="form.groups" tag-placeholder="Cari group" placeholder="Cari group"
                        label="name" track-by="id" :options="deviceGroups" :multiple="true">
                        <template slot="beforeList">
                            <div>
                                <label @click="selectNoneGrup" class="selectAll">Deselect All</label>
                                <label @click="selectAllGrup" class="selectAll">Select All</label>
                            </div>
                        </template>
                    </multiselect>
            </div>


            <br />
            <label>Message</label>
            <CustomTextArea v-model="form.message"></CustomTextArea>
            <p class="mt-2">Anda bisa menggunakan <code>[[NAME]]</code> untuk menyebut nama anggota yang bergabung ke grup</p>

            <div class="button-group d-flex pt-25">
                <button type="submit"
                    class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
                    simpan
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import CustomTextArea from "@/components/module/CustomTextarea.vue";
    import Multiselect from 'vue-multiselect'

    export default {
        components: {
            CustomTextArea,
            Multiselect
        },
        data() {
            return {
                device: [],
                deviceGroups: [],
                form: {
                    device: "",
                    name: "",
                    groups: [],
                    message: ""
                },
                loading: {
                    isGroupLoading: false
                },
                isGroupLoaded: false
            };
        },
        mounted() {
            this.getDevice()
        },
        watch: {
            'form.device': {
                handler() {
                    this.deviceGroups = []
                    this.isGroupLoaded = false
                },
                deep: true
            },
        },
        methods: {
            async addContact() {
                try {
                    let response = await this.$store.dispatch('group_create', this.form)
                    this.$toast.success(response.data.message);
                    this.$root.$emit("toggle_modal", "new_group")
                    this.$root.$emit("refresh_table", true)
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            customLabel({
                name,
                status
            }) {
                return `${name} (${status})`
            },
            selectNoneGrup() {
                this.form.groups = [];
                this.$refs.selectedItemsGrup.deactivate();
            },
            selectAllGrup() {
                this.form.groups = this.deviceGroups
                this.$refs.selectedItemsGrup.deactivate();
            },
            async getDevice() {
                let response = await this.$store.dispatch('device_list')
                this.device = response.data.data.devices
            },
            async loadGroup(device) {
                if(this.form.device == "") {
                    this.$toast.error("Pilih Device Terlebih Dahulu")
                    return
                }


                this.loading.isGroupLoading = true
                try {
                    this.deviceGroups = []
                    let res = await this.$store.dispatch("contact_load_group_device", {
                        id: parseInt(device.id)
                    });

                    this.deviceGroups = res.data.data.groups
                    for (let i = 0; i < this.deviceGroups.length; i++) {
                        this.deviceGroups[i].name = this.deviceGroups[i].name + " (" + this.deviceGroups[i].id + ")"
                    }
                    this.$toast.success("Load Group Sukses")

                    this.isGroupLoaded = true
                } catch (err) {
                    this.$toast.error("Load Group Gagal")
                }
                this.loading.isGroupLoading = false
            },
            async addGroupGreeter() {
                try {
                    let data = {
                        name: this.form.name,
                        device: this.form.device.id,
                        groups: this.form.groups.map(group => group.name.split(" ")?.[0] + ":" + group.id),
                        groups_jid: this.form.groups.map(group => group.id),
                        message: this.form.message
                    }

                    console.log(data)
                    let response = await this.$store.dispatch('group_greeter_create', data)
                    this.$toast.success(response.data.message);
                    this.$root.$emit("toggle_modal", "add_group_greeter")
                    this.$root.$emit("refresh_table", true)
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            }
        },
    };
</script>

<style scoped>
    .thick-border {
        border: 2px solid #6c6c6c !important;
    }

    .selectAll {
        display: inline-block;
        margin-right: 0.5rem;
        margin-bottom: 0.5rem;
        padding: 0.5rem 1rem;
        border: 1px solid #e5e7eb;
        border-radius: 0.5rem;
        background-color: #ffffff;
        color: #374151;
        font-size: 0.875rem;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        user-select: none;
    }

    .selectAll:hover {
        background-color: #10b981;
        color: white;
        border-color: #10b981;
        box-shadow: 0 4px 6px -1px rgba(16, 185, 129, 0.3), 0 2px 4px -1px rgba(16, 185, 129, 0.2);
        transform: translateY(-1px);
    }

    .selectAll:active {
        transform: translateY(0);
        box-shadow: 0 1px 2px 0 rgba(16, 185, 129, 0.2);
    }
</style>
